import { Injectable, Optional } from "@angular/core";
import { DwActionHandler, DwModalService, DwMenuService, DwMetaDataGridActionState, DwActionResult, DwAction, DwActionType, DwModalConfig, DwImportMetaDataModalComponent, DwModalButtonStandardConfigs, DwGridActionResult, DwRoutingService, DwModalSize, ensureArray, DwMetaDataFormStateService, DwMetaDataFormApi, DwEventService, DwGridEvents, DwUser, DwUserEntity } from "@devwareapps/devware-cap";
import { Observable, of } from "rxjs";
import { AppMetaData, AppMetaDataItemNames, AssignmentStudentEntity, CourseLessonEntity } from "../../../meta-data/app-meta-data.service";
import { map } from "rxjs/operators";
import { CourseProgressVariableContext } from "../models/course-progress-variable-context.model";

import { AppPermissions } from "../../../meta-data/app-permissions.enum";

@DwAction({
    keyName: 'lesson-assign-acs-tasks-action',
    display: 'Assign Lesson ACS Tasks',
    actionType: DwActionType.gridContextMenuAction,
    parentItemName: AppMetaDataItemNames.CourseLesson,
    isGlobal: false,
    defaultSecurityConfig: {
        requireAuthentication: true,
        useEmulatedPermissions: true,
        permissionMeaning: AppPermissions.contentAdmin
    }
})
@Injectable()
export class LessonAssignAcsTasksAction implements DwActionHandler {
    
    constructor(
        private dwModalService: DwModalService,
        private dwMenuService: DwMenuService,
        private dwRoutingService: DwRoutingService,
        private dwEventService: DwEventService
    ) {
    }

    handleAction(actionState: DwMetaDataGridActionState<any>): Observable<DwActionResult> {
        const lessons : CourseLessonEntity[] = ensureArray(actionState.data, true);

        const lessonIds = lessons.map(x => x.CourseLessonId);

        this.dwRoutingService.navigateToUrl("/lms-admin/course-management/acs-task-multi-assign?lessonIds=" + lessonIds.join(','), null);
        
        const result: DwActionResult = {
            success: true
        };

        return of(result);
    }

}